import { PsHttpService, type PatSnapCommonResponseData } from '@patsnap/tahiti-core/common/ps-http';
import { injectable } from '@patsnap/tahiti-core/shared/inversify';
import type { PreviewApiRequest, PreviewApiResponse, SearchResultApi } from '../search-result-api';

@injectable()
export class SearchResultApiImpl extends PsHttpService implements SearchResultApi {
    get options() {
        return {
            baseURL: `${import.meta.env.VITE_EUREKA_SERVICE_URI}/eureka`,
            headers: {
                'X-API-Version': '1.0',
            },
        };
    }

    preview(data: PreviewApiRequest) {
        return this.post<PatSnapCommonResponseData<PreviewApiResponse>>({
            url: '/search/preview',
            data,
        }).then((res) => {
            return res.data as PreviewApiResponse
        })
    }
}
